import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectHomeData, selectHomeIsLoading } from '@/containers/HomePage/HomeSelectors'
import { homeActions } from '@/containers/HomePage/HomeSagas'

const useHome = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const data = useSelector(selectHomeData)
  const isLoading = useSelector(selectHomeIsLoading)
  const {
    modulesStatuses,
    modulesStatusesEnergy,
    loaderRoutesEnergy,
    loaderRoutesInsurance,
    modulesStatusesInsurance,
    loaderRoutes,
    country,
    isExternal,
  } = useSelector(selectAuthData)

  const { type, getApplicationUrl, getModulesStatuses } = useBusinessType({
    loaderRoutesEnergy,
    loaderRoutes,
    modulesStatuses,
    modulesStatusesEnergy,
    loaderRoutesInsurance,
    modulesStatusesInsurance,
  })

  const endpoint = getApplicationUrl('home')

  const initialize = () => {
    dispatch({ type: homeActions.INITIALIZE_HOME, endpoint })
  }

  useEffect(() => initialize(), [])

  useEffect(() => {
    const handleGamificationUpdate = () => initialize()
    window.addEventListener('gamification-update', handleGamificationUpdate)
    return () => window.removeEventListener('gamification-update', handleGamificationUpdate)
  }, [])

  return {
    data,
    isLoading,
    moduleStatuses: getModulesStatuses(type),
    isExternal,
    country,
    type,
    t,
  }
}

export default useHome
